import { render } from "./FeesAndTaxesV2.vue.ts?vue&type=template&id=13c052ea&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FeesAndTaxesV2.vue?vue&type=template&id=13c052ea&ts=true"
import script from "./FeesAndTaxesV2.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FeesAndTaxesV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeesAndTaxesV2.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FeesAndTaxesV2.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/offers/FeesAndTaxesV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13c052ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13c052ea', __exports__)) {
    api.reload('13c052ea', __exports__)
  }
  
  module.hot.accept("./FeesAndTaxesV2.vue.ts?vue&type=template&id=13c052ea&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FeesAndTaxesV2.vue?vue&type=template&id=13c052ea&ts=true", () => {
    api.rerender('13c052ea', render)
  })

}


export default __exports__